import Icon from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';

const Hubspot = ({ style }) => {
    const styles = { width: '20px', height: '20px', ...style }
    return <img src='/icons/hubspot.svg' alt="Hubspot" style={styles} />
}
Hubspot.propTypes = {
    style: PropTypes.object
}
export const HubspotIcon = ({ style = {}, ...props }) => (
    <Icon component={Hubspot} style={style} {...props} />
)
HubspotIcon.propTypes = {
    style: PropTypes.object
}

const ExactOnline = ({ style }) => {
    const styles = { width: '18px', height: '18px', verticalAlign: 'middle', ...style }
    return <img src='/icons/exact_online.svg' alt="Exact Online" style={styles} />
}
ExactOnline.propTypes = {
    style: PropTypes.object
}
export const ExactOnlineIcon = ({ style = {}, ...props }) => (
    <Icon component={ExactOnline} style={style} {...props} />
)
ExactOnlineIcon.propTypes = {
    style: PropTypes.object
}

const Twinfield = ({ style }) => {
    const styles = { width: '18px', height: '18px', verticalAlign: 'middle', ...style }
    return <img src='/icons/headericons/twinfield.svg' alt="Twinfield" style={styles} />
}
Twinfield.propTypes = {
    style: PropTypes.object
}
export const TwinfieldIcon = ({ style = {}, ...props }) => (
    <Icon component={Twinfield} style={style} {...props} />
)
TwinfieldIcon.propTypes = {
    style: PropTypes.object
}

const Xero = ({ style }) => {
    const styles = { width: '18px', height: '18px', verticalAlign: 'middle', ...style }
    return <img src='/icons/xero.svg' alt="Xero" style={styles} />
}
Xero.propTypes = {
    style: PropTypes.object
}
export const XeroIcon = ({ style = {}, ...props }) => (
    <Icon component={Xero} style={style} {...props} />
)
XeroIcon.propTypes = {
    style: PropTypes.object
}

const Peppol = ({ style }) => {
    const styles = { width: '18px', height: '18px', verticalAlign: 'middle', ...style }
    return <img src='/icons/peppol.svg' alt="Peppol" style={styles} />
}
Peppol.propTypes = {
    style: PropTypes.object
}
export const PeppolIcon = ({ style = {}, ...props }) => (
    <Icon component={Peppol} style={style} {...props} />
)
PeppolIcon.propTypes = {
    style: PropTypes.object
}

